module.exports = __webpack_public_path__ + "static/media/instagram.ac8ddfb2.svg";